var React = require('react');

function Bullet (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 1C0 0.447716 0.447715 0 1 0H5V10H1C0.447715 10 0 9.55228 0 9V1Z","fill":"white","key":0}),React.createElement("path",{"d":"M9.29289 4.29289C9.68342 4.68342 9.68342 5.31658 9.29289 5.70711L5 10V0L9.29289 4.29289Z","fill":"white","key":1})]);
}

Bullet.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = Bullet;

Bullet.default = Bullet;
